import React, { useState, useEffect} from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import HomePage from "./components/HomePage";
import AdminForm from "./components/AdminForm";
import FullArticle from "./components/FullArticle";
import ProtectedRoute from "./components/ProtectedRoute";
import SearchPanel from "./components/SearchPanel";
import "./App.css";
import ChangePassword from "./components/ChangePassword";
import PendingArticles from "./components/PendingArticles";
import SubmitArticle from "./components/SubmitArticles";
import PublicLayout from "./layouts/PublicLayout";
import AdminLayout from "./layouts/AdminLayout";

function App() {
  // --------------------
  // Auth state
  // --------------------
  const [user, setUser] = useState(
    JSON.parse(localStorage.getItem("user")) ||
      JSON.parse(sessionStorage.getItem("user")) ||
      null
  );

	const wasFirstLogin = user?.isFirstLogin === 1;

  const navigate = useNavigate();
  const location = useLocation();
  const isArticlePage = location.pathname.startsWith("/articles/");

  const handleLogin = (loginResponse, rememberMe) => {
    const normalizedUser = {
      id: loginResponse.user.id,
      username: loginResponse.user.username,
      role: loginResponse.user.role,
      isFirstLogin: loginResponse.user.isFirstLogin,
      token: loginResponse.token
    };

    setUser(normalizedUser);

    const storage = rememberMe ? localStorage : sessionStorage;
    storage.setItem("user", JSON.stringify(normalizedUser));

		// ✅ Immediate routing decision
		if (normalizedUser.isFirstLogin) {
			navigate("/admin/change-password", { replace: true });
		}
  };

	
  const handleFirstLogin = () => {
	  navigate("/admin/change-password", { replace: true });
	};


  const handleLogout = () => {
	  localStorage.removeItem("auth_token");
	  localStorage.removeItem("user");
	  sessionStorage.removeItem("auth_token");
	  sessionStorage.removeItem("user");

	  setUser(null);
	  navigate("/");
	};

	
  const handlePasswordChanged = () => {
	  const updatedUser = { ...user, isFirstLogin: 0 };
	  setUser(updatedUser);

	  localStorage.setItem("user", JSON.stringify(updatedUser));
	  sessionStorage.setItem("user", JSON.stringify(updatedUser));

	  navigate("/admin");
	};
	

  // --------------------
  // Search / filter state (new, lifted)
  // --------------------
  const [showSearchPanel, setShowSearchPanel] = useState(false);

  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [selectedAuthor, setSelectedAuthor] = useState("all");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [categories, setCategories] = useState([]);
  const [authors, setAuthors] = useState([]);
	
  useEffect(() => {
	  if (isArticlePage) {
		setShowSearchPanel(false);
	  }
	}, [isArticlePage]);

  // --------------------
  // Render
  // --------------------
	return (
	  <div className="App">
			<Routes>
				{/* PUBLIC */}
				<Route
					element={
						<PublicLayout
							user={user}
							showSearchPanel={showSearchPanel}
							setShowSearchPanel={setShowSearchPanel}
							isArticlePage={isArticlePage}
							handleLogin={handleLogin}
							handleFirstLogin={handleFirstLogin}
							handleLogout={handleLogout}
						/>
					}
				>
					<Route
						path="/"
						element={
							<HomePage
								user={user}
								searchQuery={searchQuery}
								selectedCategory={selectedCategory}
								selectedAuthor={selectedAuthor}
								startDate={startDate}
								endDate={endDate}
								setCategories={setCategories}
								setAuthors={setAuthors}
							/>
						}
					/>

					<Route path="submit" element={<SubmitArticle />} />
					<Route path="articles/:id" element={<FullArticle />} />
				</Route>
				{/* PROTECTED */}
				<Route element={<ProtectedRoute user={user} />}>
					<Route path="/admin" element={<AdminLayout />}>
						<Route
							index
							element={
								<AdminForm
									user={user}
									onSubmit={() => window.opener?.location.reload()}
								/>
							}
						/>
						<Route
							path="pending"
							element={<PendingArticles />}
						/>
						<Route
							path="change-password"
							element={
								<AdminForm user={user}>
									<ChangePassword
										user={user}
										requireCurrentPassword={!user?.isFirstLogin}
										allowCancel={!user?.isFirstLogin}
											onPasswordChanged={() => {
												if (wasFirstLogin) {
													navigate("/");
												} else {
													navigate("/admin");
												}
											}}
									/>
								</AdminForm>
							}
						/>
					</Route>
				</Route>
			</Routes>
			{showSearchPanel && !isArticlePage && (
			<SearchPanel
				searchQuery={searchQuery}
				setSearchQuery={setSearchQuery}
				categories={categories}
				selectedCategory={selectedCategory}
				setSelectedCategory={setSelectedCategory}
				authors={authors}
				selectedAuthor={selectedAuthor}
				setSelectedAuthor={setSelectedAuthor}
				startDate={startDate}
				setStartDate={setStartDate}
				endDate={endDate}
				setEndDate={setEndDate}
			/>
			)}
	  </div>
	);

}

export default App;

